module.exports = __webpack_public_path__ + "static/media/huawei_app_launch_2.833f3ea7.png";